module.exports = __webpack_public_path__ + "static/media/298437.460d82e5.png";